import React, { useState } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from 'reactstrap';
import { observer } from "mobx-react";
import { Enum } from 'helpers';

const MergeTagsDropdown = observer(({
  atsCategorisedFieldsForMergeTags,
  onTagSelected,
  isDisabled = false,
  isAutomationContact = false,
  buttonText = "Merge tags",
  compact = false
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (isAutomationContact) {
    atsCategorisedFieldsForMergeTags = [...atsCategorisedFieldsForMergeTags, ...Enum.CandidateMergeTagsForContacts];
  }

  const filteredCategories = searchTerm
    ? atsCategorisedFieldsForMergeTags.filter(category =>
      category.atsFields.some(atsField =>
        atsField.displayName.toLowerCase().includes(searchTerm.toLowerCase())))
    : atsCategorisedFieldsForMergeTags;

  return (
    <UncontrolledDropdown sm={2} md={2} className={`d-inline ${compact ? 'w-auto' : 'w-100'}`} direction={compact ? "left" : undefined}>
      <DropdownToggle 
        color="secondary" 
        className={`mr-0 merge-tags-dropdown ${compact ? 'btn-sm px-2 py-1' : 'w-100'}`}
        id="mergeTags" 
        caret 
        disabled={isDisabled}
        style={compact ? { fontSize: '0.8rem', whiteSpace: 'nowrap' } : {}}
      >
        {buttonText}
      </DropdownToggle>
      <DropdownMenu 
        dark 
        className="merge-tags-dropdownmenu"
        flip={true}
        style={compact ? { 
          maxWidth: '300px',
          minWidth: '280px'
        } : {}}
      >
        <div className="merge-tags-search-input-container">
          <i className="fa fa-search" aria-hidden="true"></i>
          <Input
            type="search"
            placeholder="Type to search tags"
            className="merge-tags-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {filteredCategories.length > 0 && filteredCategories.map((category, categoryIndex) => (
          <React.Fragment key={categoryIndex}>
            <div className='merge-tags-bottom-line'></div>
            <DropdownItem header text className="merge-tags-header-dropdownitem">{category.categoryType}</DropdownItem>
            {category.atsFields.filter(atsField =>
              atsField.displayName.toLowerCase().includes(searchTerm.toLowerCase()))
              .map((atsField) => (
                <DropdownItem
                  className="py-2 merge-tags-childe-dropdownitem"
                  id={atsField.id}
                  key={atsField.id}
                  onClick={() => onTagSelected(atsField.tokenVariable)}
                >
                  <span className="ml-3">{atsField.displayLabel ?? atsField.displayName}</span>
                </DropdownItem>
              ))}
          </React.Fragment>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
});

export default MergeTagsDropdown;
